import OrderAddressSearchComponent from "../order/OrderAddressSearchComponent.tsx";
import {formatAmountOverPeriod, formatAmountWithCurrency} from "../../util/formatter.ts";

const pre_default = 'til'
const _default = 299
const pre_campaign = 'fra'
const campaign = 199
const time = 3
const network = 'Fibia'
const min_6 = (3 * campaign) + (3 * _default)

export default function FibiaFiberHeroComponent() {
    return (
        <>

            <div id="hero-container" className="hero-container hero-container--hiperligfiber hero-container--fibia-fiber darkteal">
                <div className="hero-background-wrapper">
                    <div className="hero-background"></div>
                </div>

                <div className="hero-content">
                    <h1>
                        <span className="hero-speed">1000 Mbit</span>
                        <span className="hero-pre-price">fibernet {pre_campaign} kun</span>
                        <span className="hero-price hero-price--99">
                            <span className="hiper-text-stroke">{campaign}</span>
                            <span className="price-comma-dash">,-</span>
                            <span className="price-md">/md.</span>
                        </span>
                        <span className="hero-price-disclaimer">
                            De første {time} måneder<br/>
                            Herefter {pre_default} {formatAmountOverPeriod(_default)}
                        </span>
                    </h1>
                </div>

                <div className="address-wrap">
                    <h2>
                        Start her<div className="scroll-down-arrow"></div>
                    </h2>
                    <OrderAddressSearchComponent/>
                </div>

                <p className="conditions">
                    Tilbuddet er inkl. gratis oprettelse, tilslutning og wifi-router.
                    Min. pris i 6 mdr. fra {formatAmountWithCurrency(min_6)} Pris efter {time} mdr. {pre_default} {_default} kr./md.
                    Tilbuddet gælder kun fiber på {network} netværk.
                    Gælder ikke alle adresser.
                    Forudsætter at du ikke har været kunde de seneste 6 mdr.
                </p>
            </div>
        </>
    )
}
